import React,{useEffect} from 'react';
import {Carousel, Col, Container, Row} from 'react-bootstrap';
import { HashLink as Link } from 'react-router-hash-link';
import {IoIosArrowDown} from 'react-icons/io';
// import pool from '../../images/swimmingPool.jpg';
import nature from '../../images/nature.jpg';
import resto from '../../images/resto.jpg';
import gym from '../../images/gym.jpg';
import exterior2 from '../../images/exterior converted/exterior2.jpg';

import Aos from "aos";
import "aos/dist/aos.css";

import './Amenities.css';


function Amenitiespage() {
    useEffect(() => {
        window.scroll(0,0)
        Aos.init({duration:2000});
      }, []);


    return (
        <>
        
            {/* <Carousel interval='5000' fade='true'  >
                <Carousel.Item className='CarouselWrapper' >
                    <img className = "CarouselPhoto"
                    src = {resto}
                    alt = "First slide" />
                    <Carousel.Caption>
                        <h3>First slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item className='CarouselWrapper' >
                    <img className = "CarouselPhoto"
                    src = {nature}
                    alt = "First slide" />
                    <Carousel.Caption>
                        <h3>Second slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item className='CarouselWrapper' >
                    <img className = "CarouselPhoto"
                    src = {gym}
                    alt = "First slide" />
                    <Carousel.Caption>
                        <h3>Third slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>  */}
            <div className='CarouselWrapperP1'>
                {/* <img className = "CarouselPhotoP"
                    src = {Rue}
                    alt = "First slide" /> */}
                    <div className='AmenitiesHeaderWrapperP'>
                        <h1 className='AmenitiesH1'>AMENITIES</h1>
                        <Link to='#amenities'>
                            <IoIosArrowDown  className='ArrowDownP'  />
                        </Link>
                    </div>
                    
            </div>


            <Container id='amenities' fluid className='bodyBackgroundA'>
                <div className='AmenitiesHeaderWrapper'>
                    <h1 className='AmenitiesH1'></h1>
                </div>
                <div className='ContentsWrapper'>
                    <div>
                        <p style={{fontSize:'20px'}}>
                        We aim for your stay with us to provide you with every luxury 
                        and comfort you desire and deserve. Numerous facilities and 
                        services cater to meet all your needs and demands for an idyllic 
                        stay. Our friendly and expert staff specializes in customizing our 
                        multitude of services to suit your exact requirements. Please feel 
                        free to contact us in advance to inform us of your needs or reach out 
                        to our reception at any time while staying with us.
                        </p>
                    </div>
                    
                <Row className='Row-box'>
                    
                    <Col xl={6} lg={6} md={6} sm={6} xs={12} className='Column1-box'>
                        <h3>Hotel Facilities</h3>
                        <ul>
                            <li>24-HOUR RECEPTION / FRONT DESK </li>
                            <li>ELEVATOR</li>
                            <li>FIRE EXTINGUISHER</li>
                            <li>EARLY CHECK-IN 9AM ONWARDS*</li>
                            <li>LATE CHECK-OUT UPTO 2PM*</li>
                            <li>AIRPORT TRANSFER SERVICE</li>
                            <li>BABY-SITTING (ON REQUEST)</li>
                            <li>DOCTOR (ON REQUEST)</li>
                            <li>CONCIERGE</li>
                            <li>DAILY HOUSEKEEPING SERVICE</li>
                            <li>LAUNDRY & IRONING SERVICE</li>
                            <li>LOBBY LOUNGE</li>
                            <li>KITCHEN AVAILABLE</li>
                            <li>REFRIGERATOR</li>
                            <li>ROOM SERVICE (24HR)</li>
                            <li>IN-ROOM FOOD SERVICE</li>
                            <li>COMPLEMENTARY WATER BOTTLE</li>
                            <li>COMPLIMENTARY BREAKFAST</li>
                            <li>LUNCH & DINNER (ON REQUEST)</li>
                            <li>TERRACE</li>
                            <li>PARKING AREA (FREE OF CHARGE)</li>
                            <li>SAFE DEPOSIT BOX</li>
                            <li>WI-FI INTERNET ACCESS (FREE OF CHARGE)</li>
                            <li>ROOM DECORATION (ON REQUEST)</li>
                        </ul>
                    <div className='travel-block'>
                        <h3 >Travel & Transportation Services</h3>
                        <ul >
                            <li>FLIGHT BOOKINGS</li>
                            <li>WEB CHECK-IN</li>
                            <li>BOARDING PASS PRINT OUT</li>
                            <li>TRAVEL ADVISORY SERVICE</li>
                            <li>TOUR ADVISOR & ORGANIZER</li>
                            <li>AIRPORT / PORT TRANSFERS ON ARRIVAL / DEPARTURE (ON REQUEST)</li>
                            <li>CAR RENTAL</li>
                            <li>TRANSFERS AND GROUND TRANSPORTATION (ON REQUEST)</li>
                        </ul>
                    </div>
                    </Col>
                    
                    
                    <Col 
                    xl={6} lg={6} md={6} sm={6} xs={12} className='Column2-box' >
                        <h3>In-Room Facilities</h3>
                        <ul>
                            <li>AIR CONDITIONING</li>
                            <li>BATH AMENITIES</li>
                            <li>BATHROOM WITH SHOWER</li>
                            <li>CLOSET</li>
                            <li>TEA/COFFEE FACILITIES</li>
                            <li>DAILY MAID SERVICE</li>
                            <li>DIRECT DIAL TELEPHONE</li>
                            <li>ELECTRIC KETTLE</li>
                            <li>FLAT SCREEN TV</li>
                            <li>SATELLITE CABLE</li>
                            <li>SMART & ANDROID TV</li>
                            <li>FULL-LENGTH MIRROR</li>
                            <li>LAUNDRY SERVICES (FEES ARE APPLIED)</li>
                            <li>HAIRDRYER</li>
                            <li>INDIVIDUALLY CONTROLLED AIR CONDITION</li>
                            <li>INDIVIDUALLY DECORATED</li>
                            <li>INDIVIDUALLY FURNISHED</li>
                            <li>IRON & IRONING BOARD</li>
                            <li>MODERN FURNISHING</li>
                            <li>NON-SMOKING ROOMS AVAILABLE</li>
                            <li>RAZOR PLUG</li>
                            <li>ROOM SERVICE (24HR)</li>
                            <li>WAKE-UP CALL</li>
                            <li>WI-FI INTERNET ACCESS (FREE OF CHARGE)</li>
                            <li>OFFICE TABLE/CHAIR</li>
                        </ul>
                    </Col>
                    
                </Row>
                    

                </div>
            </Container>
        
        </>
    )
}

export default Amenitiespage